import styleInject from '../../../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".c2-radio-button-group {\n}\n\n.c2-radio-button-group--inline {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=C2RadioButtonGroup.css.js.map
